import { useState } from "react";
import { techEvents, nonTechEvents } from "../data/eventsData";
import ZoomInIcon from "@mui/icons-material/ZoomIn";

export default function Events() {

const [activeTab, setActiveTab] = useState("tech");
const [openPoster, setOpenPoster] = useState(null);

const events = activeTab === "tech" ? techEvents : nonTechEvents;

return ( <section className="min-h-screen bg-[#0b1220] text-white pt-20 pb-24">

  <div className="max-w-7xl mx-auto px-6">

    {/* Tabs */}
    <div className="flex justify-center mb-14">
      <div className="flex gap-2 rounded-full bg-white/10 p-2 backdrop-blur-xl border border-white/20">

        <button
          onClick={() => setActiveTab("tech")}
          className={`px-6 py-2 rounded-full text-sm transition ${
            activeTab === "tech"
              ? "bg-blue-500/30 text-white"
              : "text-white/60 hover:bg-white/10"
          }`}
        >
          Tech Events
        </button>

        <button
          onClick={() => setActiveTab("nontech")}
          className={`px-6 py-2 rounded-full text-sm transition ${
            activeTab === "nontech"
              ? "bg-purple-500/30 text-white"
              : "text-white/60 hover:bg-white/10"
          }`}
        >
          Non-Tech Events
        </button>

      </div>
    </div>

    {/* Events Grid */}
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8">

      {events.map((event, idx) => (
        <div
          key={idx}
          className="rounded-2xl overflow-hidden
                     bg-white/10 backdrop-blur-xl
                     border border-white/20
                     hover:scale-[1.03] transition shadow-xl"
        >

          {/* Poster */}
          {event.poster && (
            <div
              className="relative aspect-square bg-black/20 flex items-center justify-center group cursor-pointer"
              onClick={() => setOpenPoster(event.poster)}
            >
              <img
                src={event.poster}
                alt={event.title}
                className="h-full w-full object-contain"
              />

              <div
                className="absolute inset-0 flex items-center justify-center
                           bg-black/40 opacity-0 group-hover:opacity-100
                           transition"
              >
                <ZoomInIcon sx={{ fontSize: 40 }} />
              </div>

            </div>
          )}

          {/* Content */}
          <div className="p-5 space-y-3">

            <h3 className="text-lg font-semibold text-white">
              {event.title}
            </h3>

            <p className="text-sm text-white/70">
              {event.shortDesc}
            </p>

            {event.details && (
              <ul className="text-sm text-white/70 list-disc list-inside space-y-1">
                {event.details.map((item, i) => (
                  <li key={i}>{item}</li>
                ))}
              </ul>
            )}
	    	           
            {event.date && (
              <p className="text-sm text-white/60">
                📅 {event.date}
              </p>
            )}

            {event.time && (
              <p className="text-sm text-white/60">
                ⏰ {event.time}
              </p>
            )}

            {event.venue && (
              <p className="text-sm text-white/60">
                📍 {event.venue}
              </p>
            )}

            {event.fee && (
              <p className="text-sm text-white/60">
                💰 Entry Fee: {event.fee}
              </p>
            )}

            {event.prize && (
              <p className="text-sm text-white/60">
                🏆 Prize Pool: {event.prize}
              </p>
            )}
            
            {event.posterCredits && (
  <p className="text-sm text-white">
    Poster: {event.posterCredits}
  </p>
)}

{event.contentCredits && (
  <p className="text-sm text-white">
    Content: {event.contentCredits}
  </p>
)}

            {event.contact && (
              <div className="text-sm text-white/70">
                <p className="font-medium text-white">Contact</p>

                {event.contact.map((c, i) => (
                  <p key={i}>
                    {c.name} —{" "}
                    <a
                      href={`tel:${c.phone}`}
                      className="text-blue-400 hover:underline"
                    >
                      {c.phone}
                    </a>
                  </p>
                ))}
              </div>
            )}

           {event.link && (
  <a
    href={event.link}
    target="_blank"
    rel="noreferrer"
    className="inline-block mt-4
               px-5 py-2.5 rounded-lg
               bg-blue-500 hover:bg-blue-600
               hover:shadow-lg hover:shadow-blue-500/30
               text-white text-sm font-medium transition"
  >
    Register
  </a>
)}

          </div>
        </div>
      ))}

    </div>

  </div>

  {/* Poster Viewer */}
  {openPoster && (
    <div
      className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center p-4"
      onClick={() => setOpenPoster(null)}
    >
      <img
        src={openPoster}
        alt="Event Poster"
        className="max-h-[90vh] max-w-[90vw] rounded-lg shadow-2xl"
      />
    </div>
  )}

</section>
);
}

